import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { IMAGES } from '../../constants/images';
import { getAdminData, clearAuthData } from '../../services/authService';
import '../../css/PageHeader.css';

const PageHeader = ({ title }) => {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setAdmin(getAdminData());
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const handleLogout = () => {
    clearAuthData();
    navigate('/admin/login');
  };

  return (
    <div className="page-header-bar">
      <div className="page-header-bar-inner">
        <div className="page-header-logo">
          <img src={IMAGES.NOOKLE_ICON} alt="Nookle" />
          <h1>{title}</h1>
        </div>
        <div className="page-header-actions" ref={dropdownRef}>
          <button
            className="admin-pill"
            onClick={() => setOpen((prev) => !prev)}
            aria-haspopup="true"
            aria-expanded={open}
          >
            {admin?.name || 'Admin'}
          </button>
          {open && (
            <div className="admin-dropdown">
              <div className="admin-dropdown-info">
                <div className="admin-dropdown-name">{admin?.name || '관리자'}</div>
                <div className="admin-dropdown-email">{admin?.email || '-'}</div>
                <div className="admin-dropdown-role">{admin?.role || '-'}</div>
              </div>
              <button className="admin-dropdown-logout" onClick={handleLogout}>
                로그아웃
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;